








import { Component, Vue, Prop } from 'vue-property-decorator';
import Banner from './Banner.vue';
import Info from './Info.vue';
import Content from './Content.vue';

@Component({
  components: {
    Banner,
    Info,
    Content,
  },
})
export default class GoodsIndex extends Vue {
  private scrollTop: number  = 0;
  private scroll() {
    this.scrollTop = this.$refs.content.scrollTop;
  }
}
